import Repository from './Repository';
import { Login } from '@/models/login'
import { TokenModel } from '@/models/token.model'
import { AxiosResponse } from 'axios'
import PasswordModel from '@/models/password.model'
import {Register} from "@/models/register";
import {UserPermission} from "@/models/permission.model";
import {User} from "@/models/user.models";

const resource = '/auth';

export default new class{
    auth(login: Login): Promise<AxiosResponse<TokenModel>>{
        return Repository.post<TokenModel>(resource, login);
    }
    changePassword(changePassword: PasswordModel): Promise<any>{
        return Repository.post<TokenModel>(`${resource}/password`, changePassword);
    }
    registerUser(register: Register): Promise<any>{
        return Repository.post<any>(`${resource}/register`, register);
    }
    userPermission(login: Login): Promise<AxiosResponse<UserPermission>>{
        return Repository.post<UserPermission>(`${resource}/permission`, login);
    }
    userList(): Promise<any>{
        return Repository.get<any>(`${resource}/all`);
    }
    getById(id: number): Promise<AxiosResponse<any>>{
        return Repository.get<any>(`${resource}/user/${id}`);
    }
    update(user: User): Promise<AxiosResponse<any>>{
        return Repository.post<any>(`${resource}/update-user/`, user);
    }
    delete(id: Number): Promise<AxiosResponse<any>>{
        return Repository.delete<any>(`${resource}/${id}`);
    }
}
